import React from 'react';
import coverbackground from '../../assets/ocean-bg.jpg';
import ReusableScrollCard from '../../components/ReusableScrollcard/ReusableScrollcard';

class ScrollOceans extends React.Component {
  render () { 
   return(
  
  <ReusableScrollCard             
    
        tag="EXPLORE"
        description="Oceans"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollOceans;